<template>
  <div id="editMntQuestion">
    <div class="return">
      <i class="el-icon-back" @click="goReturn">{{$t('LanguageLib.Return')}}</i>
      <span class="border"></span>
      <span class="title">{{ $t('LanguageLib.MNT_QUESTION_INFO') }}</span>
    </div>
    <div class="content">
      <el-button @click="submit('ruleForm')" type="primary" class="searchBtn" :loading="loadingSave"
                 style="margin-bottom: 7px;">{{$t('LanguageLib.SAVE')}}
      </el-button>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="ruleForm">
        <!--序号-->
        <div class="parent">
          <p class="drawerText">{{$t('LanguageLib.SERIAL_NUMBER')}}</p>
          <el-form-item>
            <el-input style="width: 320px;" oninput="this.value=this.value.replace(/[^\d]/g,'');"
                      :placeholder="$t('LanguageLib.PleaseEnter')" v-model="ruleForm.sortNo" maxlength="9">
            </el-input>
          </el-form-item>
        </div>
        <!--维修问题名称-->
        <div class="parent">
          <p class="drawerText"><span class="colorRed">*</span>&nbsp;{{$t('LanguageLib.MNT_QUESTION_NAME')}}</p>
          <el-form-item style="min-width: 700px" prop="questionName">
            <el-input style="width: 320px;display: inline-block" :placeholder="$t('LanguageLib.PleaseEnter')"
                      v-model="ruleForm.questionName"
                      @change="inputCategory"
                      maxlength="50">
            </el-input>
            <el-select style="display: inline-block;width: 122px" v-model="currentLang"
                       @change="changeLanguage"
                       :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
              <span slot="prefix" v-if="currentLang===OwnerLanguage" style="position: relative;color: red">*</span>
              <el-option
                v-for="item in langList"
                :key="item.id"
                :label="item.content"
                :value="item.id"
              >
                <div><span style="color: red" v-if="item.id===OwnerLanguage">*</span>
                  <span v-else style="visibility: hidden">*</span>
                  {{item.content}}
                </div>
              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <!--维修问题分类-->
        <div class="parent">
          <p class="drawerText"><span class="colorRed">*</span>{{$t('LanguageLib.MNT_QUESTION_CATEGORY')}}</p>
          <el-form-item prop="categoryId">
            <el-select style="width: 320px;" v-model="ruleForm.categoryId" clearable
                       :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
              <el-option
                v-for="item in categoryList"
                :key="item.id"
                :label="item.problemCategory"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <!--默认优先级-->
        <div class="parent">
          <p class="drawerText">{{$t('LanguageLib.DEFAULT_PRIORITY')}}</p>
          <el-form-item>
            <el-select style="width: 320px;" v-model="ruleForm.defaultPriorityId" clearable
                       :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
              <el-option
                v-for="item in priorityList"
                :key="item.id"
                :label="item.dataName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import storeMntApi from '../../api/storeMnt'
import storeinformationApi from '../../api/storeinformation'

export default {
  name: 'EditMntQuestion',
  data () {
    var checkCategoryId = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('LanguageLib.MNT_QUESTION_CATEGORY') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        if (this.$commonfun.isNull(value)) {
          return callback(new Error(this.$t('LanguageLib.MNT_QUESTION_CATEGORY') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
        } else {
          callback()
        }
      }
    }
    return {
      change: '',
      currentLang: '', // 当前选中的语言
      OwnerLanguage: 0, // 店铺默认语言
      langList: [], // 语言列表
      priorityList: [], // 默认优先级数据源
      categoryList: [], // 维修问题分类数据源
      mntProblemCategoryList: [],
      loadingSave: false,
      rules: {
        categoryId: [
          {
            validator: checkCategoryId,
            trigger: 'clear'
          },
          {
            validator: checkCategoryId,
            trigger: 'change'
          }
        ]
      },
      mpid: '',
      multiLingualList: [{
        id: '',
        content: ''
      }], // 多语言列表
      ruleForm: {
        questionName: '',
        categoryId: '', // 分类ID
        defaultPriorityId: null, // 默认优先级
        sortNo: 0
      }
    }
  },
  created () {
    const query = JSON.parse(this.$commonfun.decodeUrl(this.$route.query.myQuery))
    console.log(query)
    this.type = query.type
    if (this.type === 'add') {
      this.getNo()
      this.ruleForm.categoryId = query.pcid
    } else {
      this.mpid = query.mpid
    }
    this.getCategory()
    this.getPriorityList()
    this.getLangList()
  },
  methods: {
    getMntQuestionDetail () {
      storeMntApi.getMntProblemDetail('get', '/mnt/problem/detail?mpid=' + this.mpid)
        .then(res => {
          const mntQuestion = res.data
          this.ruleForm.sortNo = mntQuestion.sortNo
          for (let i = 0; i < this.priorityList.length; i++) {
            if (mntQuestion.defaultPriorityId === this.priorityList[i].id) {
              this.ruleForm.defaultPriorityId = mntQuestion.defaultPriorityId
            }
          }
          this.ruleForm.categoryId = mntQuestion.categoryId
          for (let i = 0; i < this.multiLingualList.length; i++) {
            for (let j = 0; j < mntQuestion.multiLingualList.length; j++) {
              if (this.multiLingualList[i].ownerLanguage === mntQuestion.multiLingualList[j].ownerLanguage) {
                this.multiLingualList[i].content = mntQuestion.multiLingualList[j].content
                this.multiLingualList[i].id = mntQuestion.multiLingualList[j].id
              }
            }
          }
          this.changeLanguage()
          this.$forceUpdate()
        })
    },
    inputCategory (e) {
      // 每次打字都修改对应的语言的名字
      this.multiLingualList[this.currentLang].content = e
    },
    changeLanguage () {
      // 每次改语言,都把input框应该有的内容给读进去
      this.ruleForm.questionName = this.multiLingualList[this.currentLang].content
    },
    getNo () {
      storeMntApi.getMntProblemNo('get', '/mnt/problem/sortNo')
        .then(res => {
          this.ruleForm.sortNo = res.data
        })
    },
    getCategory () {
      storeMntApi.getMntProblemCategorys('get', '/mnt/getMntProblemCategorys')
        .then(res => {
          this.categoryList = res.data
          this.categoryList = this.categoryList.map(x => {
            if (x.problemCategory == null) {
              x.problemCategory = ' '
            }
            return x
          })
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    },
    getPriorityList () {
      storeMntApi.getPriorityList('get', '/mnt/getDatadicts?dataDictType=Priority')
        .then(res => {
          this.priorityList = res.data
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    },
    getLangList () {
      // 获取店铺多语言列表
      storeinformationApi.getLang('get', '/BasicData/GetLang', {
        pageIndex: 1,
        pageSize: 2147483647
      })
        .then(res => {
          var OwnerLanguage = this.$commonfun.localStorage.getitem('OwnerLanguage') * 1
          this.OwnerLanguage = OwnerLanguage
          this.langList = res.data
          this.multiLingualList = this.langList.map(x => {
            x.content = ''
            x.ownerLanguage = x.typeValue
            return x
          })
          this.langList = this.langList.map(x => {
            const obj = {}
            obj.id = x.typeValue
            obj.content = x.typeDes
            if (obj.id === OwnerLanguage) {
              this.currentLang = OwnerLanguage
            }
            return obj
          })
          if (this.type === 'edit') {
            this.getMntQuestionDetail()
          }
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    },
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadingSave = true
          if (this.type === 'add') {
            const newQuestion = {}
            newQuestion.sortNo = this.ruleForm.sortNo
            newQuestion.defaultPriorityId = this.ruleForm.defaultPriorityId
            newQuestion.categoryId = this.ruleForm.categoryId
            newQuestion.multiLingualList = this.multiLingualList.map(x => {
              const y = {}
              y.content = x.content
              y.ownerLanguage = x.ownerLanguage

              return y
            })

            storeMntApi.createMntProblem('post', '/mnt/problem/add', newQuestion)
              .then(res => {
                this.loadingSave = false
                const qr = JSON.parse(this.$commonfun.decodeUrl(this.$route.query.myQuery))
                const x = {
                  pageIndex: qr.pageIndex,
                  pageSize: qr.pageSize,
                  search: qr.search,
                  sort: qr.sort,
                  sortOrder: qr.sortOrder,
                  pcid: qr.pcid
                }
                const myQuery = this.$commonfun.encodeUrl(JSON.stringify(x))
                this.$router.push({
                  path: '/storemnt/mntquestion',
                  query: {
                    fromPath: 'editmntquestion',
                    myQuery: myQuery
                  }
                })
              })
              .catch(err => {
                this.loadingSave = false
                this.$commonfun.console.log(err)
              })
          } else {
            const editQuestion = {}
            editQuestion.mpid = this.mpid
            editQuestion.sortNo = this.ruleForm.sortNo
            editQuestion.defaultPriorityId = this.ruleForm.defaultPriorityId
            editQuestion.categoryId = this.ruleForm.categoryId
            editQuestion.multiLingualList = this.multiLingualList.map(x => {
              const y = {}
              y.id = x.id
              y.content = x.content
              y.ownerLanguage = x.ownerLanguage
              return y
            })
            storeMntApi.updateMntProblem('post', '/mnt/problem/change', editQuestion)
              .then(res => {
                this.loadingSave = false
                const qr = JSON.parse(this.$commonfun.decodeUrl(this.$route.query.myQuery))
                const x = {
                  pageIndex: qr.pageIndex,
                  pageSize: qr.pageSize,
                  search: qr.search,
                  sort: qr.sort,
                  sortOrder: qr.sortOrder,
                  pcid: qr.pcid
                }
                const myQuery = this.$commonfun.encodeUrl(JSON.stringify(x))
                this.$router.push({
                  path: '/storemnt/mntquestion',
                  query: {
                    fromPath: 'editmntquestion',
                    myQuery: myQuery
                  }
                })
              })
              .catch(err => {
                this.loadingSave = false
                this.$commonfun.console.log(err)
              })
          }
        }
      })
    },
    goReturn () {
      this.loadingSave = false
      const qr = JSON.parse(this.$commonfun.decodeUrl(this.$route.query.myQuery))
      const x = {
        pageIndex: qr.pageIndex,
        pageSize: qr.pageSize,
        search: qr.search,
        sort: qr.sort,
        sortOrder: qr.sortOrder,
        pcid: qr.pcid
      }
      const myQuery = this.$commonfun.encodeUrl(JSON.stringify(x))
      this.$router.push({
        path: '/storemnt/mntquestion',
        query: {
          fromPath: 'editmntquestion',
          myQuery: myQuery
        }
      })
    }
  }
}
</script>

<style lang="scss">
  #editMntQuestion {
    height: 100%;
    width: 100%;

    .buttonSlot {
      padding: 0 4px;
      color: white;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      border-radius: 5%;
      cursor: pointer;
      width: 98px;
      margin: 0 1px;
      text-overflow: ellipsis;
      overflow: hidden;
      background-color: #3BC6B9;
      border-color: #3BC6B9;
      height: 30px;
      margin-bottom: 15px;

      .buttonContent {
        display: inline-block;
        margin-right: 3px;
      }

      .buttonContent.text {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    .storePic {
      overflow: hidden;

      .parent {
        float: left;
        width: auto;
        position: relative;
        margin-bottom: 16px;

        img {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          border: 1px solid #E1E1E1;
        }

        .drawerText {
          width: 100px;
          text-align: center;
          margin-top: 4px;
        }

        input {
          position: absolute;
          left: 10px;
          width: calc(100% - 10px);
          height: 30px;
          top: 0;
          opacity: 0;
        }

        .el-button--primary {
          margin-left: 2px;
          display: inherit;
          margin-bottom: 8px;
          font-size: 14px;
        }

        .el-button--primary:nth-of-type(2) {
          background: #fff;
          color: #C0C4CC;
          border: 1px solid rgba(216, 220, 230, 1);
        }
      }
    }

    .TeInput input {
      border-right: 0px;
      border-radius: 4px 0 0 4px;
    }

    .left {
      width: 320px !important;
    }

    .return {
      padding-left: 25px;
      position: relative;
      height: 50px;
      background: rgba(255, 255, 255, 1);
      line-height: 50px;
      border-bottom: 1px solid #F2F2F2;

      .el-icon-back {
        margin-right: 15px;
        cursor: pointer;
      }

      .border {
        position: absolute;
        height: 37px;
        border-left: 1px solid #f1f1f1;
        display: inline-block;
        top: 5px;
      }

      .title {
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        margin-left: 15px;
      }
    }

    .content::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }

    .content::-webkit-scrollbar-thumb {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      background: #E1E1E1;
    }

    .content::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      border-radius: 5px;
      background: #fff;
    }

    .content {
      background: rgba(255, 255, 255, 1);
      width: 100%;
      height: calc(100% - 66px);
      overflow-y: auto;
      overflow-x: hidden;
      padding: 0 100px;
      padding-top: 15px;
      box-sizing: border-box;

      /*组织树视图*/
      .el-dialog {
        overflow: hidden;
        width: 360px !important;

        .left {
          background: #fff;
          width: 320px;
          height: 535px;
          border: 1px solid #f2f2f2;

          .fifter {
            height: 30px;
            padding: 10px 0 10px 20px;
            margin: 0 auto;
            border-bottom: 1px solid #f2f2f2;

            .el-input {
              width: 220px;

              input {
                height: 30px;
                line-height: 30px;
                border-radius: 20px;
              }

              .el-icon-search {
                line-height: 30px;
              }
            }

            .el-button--text {
              margin-left: 8px;
              padding: 7px 0;
              color: #3BC6B9;
            }
          }

          .treeBox {
            height: calc(100% - 51px);
            overflow: auto;
            width: 320px;
          }

          .treeBox::-webkit-scrollbar {
            width: 10px;
            height: 10px;
          }

          .treeBox::-webkit-scrollbar-thumb {
            border-radius: 5px;
            -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
            background: #E1E1E1;
          }

          .treeBox::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
            border-radius: 5px;
            background: #fff;
          }
        }
      }

      .el-textarea__inner {
        font: 400 13.3333px Arial;
      }

      .cropper-content {
        background: #f2f2f2;
        padding-top: 20px;
        /*display: flex;
        display: -webkit-flex;
        justify-content: flex-end;
        -webkit-justify-content: flex-end;*/
        .cropper {
          width: 400px;
          height: 400px;
          margin: 0 auto;
        }

        .show-preview {
          flex: 1;
          -webkit-flex: 1;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          -webkit-justify-content: center;

          .preview {
            overflow: hidden;
            border-radius: 50%;
            border: 1px solid #cccccc;
            background: #cccccc;
            margin-left: 40px;
          }
        }
      }

      .footer-btn {
        padding-top: 20px;
        background: #f2f2f2;
        /*display: flex;
        display: -webkit-flex;
        justify-content: flex-end;
        -webkit-justify-content: flex-end;*/
        .scope-btn {
          width: 400px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;
          -webkit-justify-content: space-between;
          margin: 0 auto;

          .el-button--primary {
            max-width: 98px;
            margin: 0 1px;
            text-overflow: ellipsis;
            overflow: hidden;
            background-color: #3BC6B9;
            border-color: #3BC6B9;
            height: 30px;
            margin-bottom: 15px;
            margin-left: 0;
          }

          span {
            display: block;
            float: left;
          }
        }

        .upload-btn {
          flex: 1;
          -webkit-flex: 1;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          -webkit-justify-content: center;
        }
      }

      .label-success {
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        -webkit-appearance: none;
        text-align: center;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        outline: 0;
        margin: 0;
        -webkit-transition: 0.1s;
        transition: 0.1s;
        font-weight: 500;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        padding: 12px 20px;
        font-size: 14px;
        border-radius: 4px;
        color: #fff;
        background-color: rgb(103, 194, 58) !important;
        border-color: rgb(103, 194, 58) !important;
      }

      .label-success:hover {
        background-color: rgb(133, 206, 97) !important;
        border-color: rgb(133, 206, 97) !important;
      }

      .dialogStoreComm {
        .el-dialog {
          width: 500px !important;
          height: 660px !important;

          .el-dialog__header {
            padding: 20px;
            border-bottom: 1px solid #EBEEF5;
          }

          .el-dialog__body {
            padding: 20px;
          }
        }
      }

      .drawerText {
        margin-bottom: 5px;
        height: 16px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(77, 77, 77, 1);
        line-height: 16px;
      }

      h4 {
        font-size: 16px;
        color: #000;
        font-weight: normal;
        padding-top: 8px;
      }

      .contentTop {
        padding: 15px 0 24px 20px;

        .el-checkbox {
          margin-right: 30px;
        }
      }

      .infoForm {
        padding: 15px 0 0 20px;

        .parent {
          width: 50%;
          vertical-align: top;
          display: inline-block;
        }
      }
    }

    /*修改按钮样式*/
    .el-button--primary {
      background-color: #3BC6B9;
      border-color: #3BC6B9;
      padding: 7px 20px;
      margin-bottom: 15px;
      margin-left: 0;
    }

    .colorRed {
      color: red;
    }

    .el-textarea__inner {
      font: 400 13.3333px Arial;
    }
  }

  .el-range-editor.el-input__inner {
    width: 320px;
  }

  .el-textarea {
    textarea {
      height: 124px;
    }
  }
</style>
